<template>
  <div class="statistics">
    <div class="row">
      <div class="key">合计配送单数量:</div>
      <div class="val">{{ selectList.length }}</div>
    </div>
    <div class="row">
      <div class="key">合计出货商品数量:</div>
      <div class="val">{{ statistics.goods_num_total.toFixed(2) }}</div>
    </div>
    <div class="row">
      <div class="key">合计出货商品金额:</div>
      <div class="val">{{ statistics.shipment_amount.toFixed(2) }}</div>
    </div>
    <div class="row" v-if="statistics.box_amount">
      <div class="key">合计累计箱数:</div>
      <div class="val">{{ statistics.box_amount }}</div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    selectList: { type: Array },
  },
  computed: {
    statistics() {
      let total = {
        goods_num_total: 0,
        shipment_amount: 0,
        box_amount: 0,
      }
      this.selectList.forEach(item => {
        total.shipment_amount += item.shipment_amount - 0
        total.goods_num_total += item.goods_num_total - 0
        item.express_invoice.forEach(box => {
          total.box_amount += box.box_count - 0
        })

      })
      return total
    }
  },
  data() {
    return {

    };
  },
  methods: {

  }
}
</script>
<style lang='scss' scoped>
.row {
  display: flex;
  margin-bottom: 5px;
  color: #000;

  .key {
    width: 120px;
    margin-right: 10px
  }

  .val {
    color: #B4272D;
  }
}

/deep/.el-popover {
  background-color: pink !important;
}
</style>